export default __webpack_public_path__ + "static/media/Brew of Acute Foresight.c3286e53.jpg";